import { Link } from 'react-router-dom';
import { featureComparison } from '@/mocks/homeData';

export default function ContentHub() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="lg:w-[50%] w-full">
            <div className="rounded-[32px] overflow-hidden border border-background-200/50">
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20composition%20of%20fashion%20lifestyle%20elements%20including%20denim%20jacket%20sleeve%20sneaker%20detail%20leather%20bag%20handle%20and%20watch%20strap%20arranged%20in%20diagonal%20flow%20on%20textured%20white%20paper%20background%20soft%20directional%20light%20from%20upper%20left%20creating%20subtle%20gradient%20shadows%20editorial%20product%20collage%20with%20generous%20negative%20space&width=800&height=600&seq=contenthub-v2-3p8r&orientation=squarish"
                alt="Hipobuy Spreadsheet product collage"
                className="w-full h-auto object-cover"
                loading="lazy"
              />
            </div>
          </div>

          <div className="lg:w-[50%]">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium font-label mb-4">
              Hipobuy Sheet Research
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 leading-tight">
              What Is Hipobuy<br />Spreadsheet?
            </h2>
            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed">
              Hipobuy Spreadsheet is a structured product research resource that helps shoppers discover products through organized lists, category collections, and comparison guides. Instead of searching randomly across multiple platforms, users can explore curated spreadsheet resources that simplify product discovery and save valuable research time.
            </p>

            <div className="mt-8 overflow-hidden rounded-2xl border border-background-200/70">
              <table className="w-full text-sm">
                <thead>
                  <tr className="bg-background-100">
                    <th className="text-left px-5 py-3 font-semibold text-foreground-900 font-label text-xs">
                      Feature
                    </th>
                    <th className="text-left px-5 py-3 font-semibold text-foreground-500 font-label text-xs">
                      Normal Searching
                    </th>
                    <th className="text-left px-5 py-3 font-semibold text-primary-600 font-label text-xs">
                      Hipobuy Spreadsheet
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {featureComparison.map((row, i) => (
                    <tr key={i} className="border-t border-background-200/50">
                      <td className="px-5 py-3 text-foreground-800 font-medium">{row.feature}</td>
                      <td className="px-5 py-3 text-foreground-500">{row.normal}</td>
                      <td className="px-5 py-3 text-primary-700 font-medium">{row.hipobuy}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <Link
              to="/best-hipobuy-spreadsheet-guide-2026/"
              className="mt-7 inline-flex items-center justify-between w-full sm:w-auto gap-3 px-6 py-3 rounded-full bg-background-100 border border-background-300/60 text-foreground-900 text-sm font-semibold hover:bg-background-200 transition-all duration-200 whitespace-nowrap"
            >
              <span>Read Full SEO Guide</span>
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-base"></i>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}